import { motion } from 'framer-motion';
import type { CallQuality } from '@/lib/call-quality-monitor';

interface CallQualityIndicatorProps {
  quality: CallQuality;
}

const barConfig: Record<CallQuality, { bars: number; color: string }> = {
  excellent: { bars: 3, color: '#22c55e' },
  good:      { bars: 2, color: '#eab308' },
  poor:      { bars: 1, color: '#ef4444' },
  critical:  { bars: 0, color: '#ef4444' },
};

export function CallQualityIndicator({ quality }: CallQualityIndicatorProps) {
  const { bars, color } = barConfig[quality];
  const barHeights = [6, 10, 14];

  return (
    <motion.div
      className="flex items-end gap-[2px]"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: 'spring', stiffness: 400, damping: 25 }}
      aria-label={`Call quality: ${quality}`}
    >
      {barHeights.map((h, i) => (
        <motion.div
          key={i}
          className="w-[3px] rounded-full"
          style={{
            height: h,
            backgroundColor: i < bars ? color : 'rgba(255,255,255,0.2)',
          }}
          animate={{
            backgroundColor: i < bars ? color : 'rgba(255,255,255,0.2)',
          }}
          transition={{ duration: 0.4 }}
        />
      ))}
    </motion.div>
  );
}
